<template>
  <div :class="['page-association-table', props?.source == 30 ? 'page-wrap-add' : 'page-wrap-detail']">
    <template v-if="gettableLeverModulue?.modules?.length">
      <qf-table :checkedParams="{ enabled: false, width: 60 }" :hasPagination="false" :columns="getColumns(gettableLeverModulue?.modules)" :data="[{}]" :expandIcon="newGetTableLevel(gettableLeverModulue)?.modules?.length" v-model:expandedRowKeys="expandedRowKeys" @expandChange="rehandleExpandChange">
        <template #expandIcon="{ rowKey }">
          <div class="fh-table-expand-icon">
            <qfei-icon-caret-right-outlined v-if="!expandedRowKeys.includes(rowKey)" style="font-size: 10px" />
            <qfei-icon-caret-down-outlined v-else style="font-size: 10px" />
          </div>
        </template>
        <template v-if="additionalBusiness == 1" #expandRow>
          <association-table :ele="newGetTableLevel(gettableLeverModulue)" :additionalBusiness="additionalBusiness"></association-table>
        </template>
      </qf-table>

      <!-- <jw-table class="custom-scroll-table" sticky-header :hoverable="false" :bordered="{ cell: true }" row-key="id" :scrollbar="false" :pagination="false" :data="[{}]" ref="xlUserTable1" :columns="getColumns(gettableLeverModulue?.modules)" :expandable="newGetTableLevel(gettableLeverModulue)?.modules?.length ? expandable : ''" :class="['object-table', !newGetTableLevel(gettableLeverModulue)?.modules?.length ? 'expand-table' : '']">
        <template v-if="additionalBusiness == 1" #expand-row>
          <div class="table-level-content">
            <association-table :ele="newGetTableLevel(gettableLeverModulue)" :additionalBusiness="additionalBusiness"></association-table>
          </div>
        </template>
      </jw-table> -->
    </template>
    <template v-else>
      <!-- 空白表格 -->
      <div class="null-table">
        <div class="null-table-item" v-for="(item, index) in widths" :key="index" :style="{ width: item }">
          <div class="null-table-skeleton">
            <jw-space direction="vertical" :style="{ width: '100%' }" size="small">
              <jw-skeleton-line :rows="1" />
            </jw-space>
          </div>
          <div style="height: 40px"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { h, watchEffect, ref } from 'vue';
const props = defineProps({
  source: {
    //来源 20：详情，30：新建编辑
    type: [String, Number],
    default: '30'
  },
  ele: {
    type: [Object, Array],
    default: () => {}
  },
  // 是否开启多层
  additionalBusiness: {
    type: [Number, String],
    default: 0
  }
});
const widths = ['20%', '25%', '15%', '15%', '25%'];
// 展开行配置
// const expandable = reactive({
//   title: '',
//   width: 80
// });
const expandedRowKeys = ref([]);

//点击展开图标(加载二级)
const rehandleExpandChange = async ({ expandRowKeys }) => {
  expandedRowKeys.value = [];
  if (expandRowKeys && expandRowKeys?.length) {
    // 更新展开状态
    expandedRowKeys.value.push(expandRowKeys[expandRowKeys.length - 1]);
  }
};
console.log('多层级', rehandleExpandChange);
const gettableLeverModulue = ref(props.ele);
watchEffect(() => {
  gettableLeverModulue.value = props.ele;
});
//  判断是否展示层级表格
const newGetTableLevel = (ele) => {
  const getColumnsList = ele?.modules?.filter((item) => item?.type == 31);
  if (props.additionalBusiness == 1 && getColumnsList && getColumnsList?.length && getColumnsList?.[0]?.modules?.length > 0) {
    return getColumnsList?.[0];
  } else {
    return [];
  }
};
console.log('多层级2', newGetTableLevel);
const skeletonStyles = {
  display: 'inline-block',
  width: '80%',
  height: '16px',
  backgroundColor: 'var(--color-fill-2)'
};
// 从所有字段中获取表格头部标题
const getColumns = (fieldList) => {
  const list = [];
  const getColumnsList = fieldList;
  const result = getColumnsList?.filter((item) => item?.type !== '40');
  result?.forEach((item) => {
    let colType = {};
    if ((item?.fieldType == 27 || item?.type == 35) && item?.modules?.length) {
      const _children = [];
      item?.modules.map((im) => {
        _children.push({
          title: im.label,
          dataIndex: `${item.value}+${im.value}`,
          width: 150,
          render: () => {
            return h('div', { style: skeletonStyles });
          }
        });
      });
      colType = {
        title: item.label,
        children: _children,
        align: 'left'
      };
    } else {
      colType = {
        title: item.label,
        dataIndex: item.value,
        width: 150,
        align: 'left',
        render: () => {
          return h('div', { style: skeletonStyles });
        }
      };
    }
    if (item?.type == 20 || item?.type == 35) {
      //字段，子表单
      list.push(colType);
    }
  });
  return list;
};
</script>
<style scoped lang="less">
@import './association-table.less';
</style>
